/**
 * 文件题上传zip
*/
import Vue from 'vue';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import ossClient from './aliyun.oss.client';
import ElementUI, { Upload } from 'element-ui';
import store from '../vuex/store';
import utils from './util';
import wsMethod from './socketMethod'
var $base64 = require("js-base64").Base64;
var uploadConf = {
    accessKeyId: '',
    accessKeySecret: '',
    stsToken: '',
    bucket: 'aitestgo-bj-art',
    endpoint: 'oss-cn-beijing.aliyuncs.com',
    secure:true
}
var uploadName = ''
var upload = ''
var ifcancel_d=false;
const parallel = 1;
const partSize = 1000 * 1024;
const timeout = 60000;
var checkpoints = {};
var client = {};
var serial = '';
var upFiles = [];
var upFiles_name = [];
var errorNum = 0;//默认是aitestgo-bj 上传错误三次后更换为aitestgo-qd
var isCancel = false;//是否手动取消上传
//上传文件
export async function uploadPic(file,callback){
    let that = this
    await Vue.prototype.$axios.post('/oss/stsInfo/list',{
        uid:Number($base64.decode(window.localStorage.getItem('uid-web')))
    },res => {
        let v = res.data;
        if (v!=undefined&&v.code == 0) {
            let vlistVal = {}
            let is_edit = false
            // >=3时切换 <3保持
            if(errorNum>=3){
                is_edit = true
                if(uploadConf.bucket == 'aitestgo-bj-art'){
                    vlistVal = v.data[1]   
                }else if(uploadConf.bucket == 'aitestgo-qd'){
                    vlistVal = v.data[0]
                }
                errorNum = 0
            }else{
                if(uploadConf.bucket == 'aitestgo-bj-art'){
                    vlistVal = v.data[0]
                }else{
                    vlistVal = v.data[1]
                }
            }
            uploadConf.accessKeyId = vlistVal.accessKeyId
            uploadConf.accessKeySecret = vlistVal.accessKeySecret
            uploadConf.stsToken = vlistVal.securityToken//stsToken
            uploadConf.bucket = vlistVal.bucket
            uploadConf.endpoint = vlistVal.url.split(`${vlistVal.bucket}.`)[1]
            return callback(uploadConf,is_edit)
        }
    });
}
export async function uploadHttp(file,callback,serial='') {
    let that = this
    that.serial = serial
    wsMethod.wsSend212()
    that.uploadPic(file,function (val,is_edit) {
        let jwStr = file.name.split('.')[file.name.split('.').length - 1]
        const nowFileName = file.name.replace(`.${jwStr}`,`-${utils.uuid2(5)}.${jwStr}`)
        var fileName = `${process.env.ANSWER_OSS}/${file.room}/${nowFileName}`
        store.commit('get_add_tempFiles',{
            name:fileName,
            serial:serial,
            file:file
        })
        Nprogress.start()
        client = ossClient(val)
        ossClient(val).multipartUpload(fileName, file,{
            parallel,
            partSize,
            timeout,
            progress:function(progress,checkpoint){
                if(checkpoint){//分片
                    store.commit('get_add_checkpoint',{
                        'fileName':fileName,
                        'serial':serial,
                        'checkpoint':checkpoint
                    })
                    store.commit('get_add_uploadID',{
                        'serial':serial,
                        'upload':checkpoint.uploadId,
                        'uploadName':checkpoint.name,
                        'client':ossClient(val),
                    })         
                    upload = checkpoint.uploadId
                    uploadName = checkpoint.name
                }
                store.commit('get_add_zipLoading',{
                    'serial':serial,
                    'value':Number(utils.toPercent(progress))
                })
            }
        }).then(({res, url, name})=> {
            Nprogress.done()
            if (res && res.status == 200) {
                // socket213
                wsMethod.wsSend213()
                // 删除暂存
                store.commit('get_delete_tempFiles',{'name':fileName})
                // 删除切片
                store.commit('get_delete_checkpoint',{"name":fileName})
                // 删除进度
                store.commit('get_delete_zipLoading',serial)
                // 删除上传id
                store.commit('get_delete_uploadID',serial)
                let urls = String(res.requestUrls[0])
                return callback(decodeURIComponent(urls.split('?')[0],file))
            }
        }).catch(err=> {
            Nprogress.done()
            // 捕获超时异常。
            wsMethod.wsSend214()
            if (ossClient(val) && ossClient(val).isCancel()) {
                console.log('stop-upload!');
            } else {
                //手动取消
                if(isCancel){
                    isCancel = false
                    // 删除暂存
                    store.commit('get_delete_tempFiles',{'serial':serial})
                    // 删除切片
                    store.commit('get_delete_checkpoint',{'serial':serial})
                    // 删除进度
                    store.commit('get_delete_zipLoading',serial)
                    // 删除错误
                    store.commit('get_delete_zipError',serial)
                    // 删除上传id
                    store.commit('get_delete_uploadID',serial)
                    return callback()
                }
                errorNum++;
                let flows = {}
                flows.serial = serial,
                flows.callback = callback
                store.commit('get_add_zipError',flows);
                // 上传失败尝试续传
                getNetworkError(function(network){
                    console.log('查询得知网络情况',network)
                    if(network){
                        resumeUpload(serial,callback)
                    }else{
                        return callback('','net')
                    }
                })
            }
        });
    })
}

// 续传
export async function resumeUpload(serial='',callback) {
    let that = this
    let file,fileName;
    let tempFiles_xc = store.getters.is_isZip_tempFiles
    for (let i = 0; i < tempFiles_xc.length; i++) {
        if(tempFiles_xc[i].serial == serial){
            file = tempFiles_xc[i].file
            fileName = tempFiles_xc[i].name
        }
    }
    uploadPic(file,function (val,is_edit) {
        if(is_edit){//切区
            if(file.name) //过滤损坏的文件
            cut_resumeUpload(file,val,fileName,serial,callback)
        }else{//持续
            var checkpoint_temp = null;
            for (let i = 0; i < store.getters.is_isZip_checkpoint.length; i++) {
                if(store.getters.is_isZip_checkpoint[i].name == fileName){
                    checkpoint_temp = store.getters.is_isZip_checkpoint[i].cpt
                }
            }
            if(checkpoint_temp.file.name)
            shun_resumeUpload(file,val,fileName,serial,callback,checkpoint_temp)
        }
    })
}
//持续续传
export async function shun_resumeUpload(file,val,fileName,serial,callback,checkpoint_temp) {
    var fileName = fileName
    wsMethod.wsSend212()
    console.log('持续续传--:',val.bucket)
    Nprogress.start()
    // 删除错误
    store.commit('get_delete_zipError',serial)
    client = ossClient(val)
    ossClient(val).multipartUpload(fileName, file,{
        parallel,
        partSize,
        timeout,
        progress:function(progress,checkpoint){
            if(checkpoint){//分片
                store.commit('get_add_checkpoint',{
                    'fileName':fileName,
                    'serial':serial,
                    'checkpoint':checkpoint
                })
                store.commit('get_add_uploadID',{
                    'serial':serial,
                    'upload':checkpoint.uploadId,
                    'uploadName':checkpoint.name,
                    'client':ossClient(val),
                })             
                upload = checkpoint.uploadId
                uploadName = checkpoint.name
            }
            store.commit('get_add_zipLoading',{
                'serial':serial,
                'value':Number(utils.toPercent(progress))
            })
        },
        checkpoint:checkpoint_temp,
    }).then(({res, url, name})=> {
        Nprogress.done()
        if (res && res.status == 200) {
            wsMethod.wsSend213()
            // 删除暂存
            store.commit('get_delete_tempFiles',{'name':fileName})
            // 删除切片
            store.commit('get_delete_checkpoint',{"name":fileName})
            // 删除进度
            store.commit('get_delete_zipLoading',serial)
            // // 删除错误
            // store.commit('get_delete_zipError',serial)
            // 删除上传id
            store.commit('get_delete_uploadID',serial)
            let urls = String(res.requestUrls[0])
            return callback(decodeURIComponent(urls.split('?')[0],file))
        }
    }).catch(err=> {
        Nprogress.done()
        wsMethod.wsSend214()
        //手动取消
        if(isCancel){
            isCancel = false
            // 删除暂存
            store.commit('get_delete_tempFiles',{'serial':serial})
            // 删除切片
            store.commit('get_delete_checkpoint',{'serial':serial})
            // 删除进度
            store.commit('get_delete_zipLoading',serial)
            // 删除错误
            store.commit('get_delete_zipError',serial)
            // 删除上传id
            store.commit('get_delete_uploadID',serial)
            return callback()
        }
        errorNum++;
        store.commit('get_add_zipError',{
            'serial':serial,
            'callback':callback
        });
        // 上传失败尝试续传
        getNetworkError(function(network){
            console.log('续传 - 查询得知网络情况',network)
            if(network){
                resumeUpload(serial,function(e){
                    return callback(e)  
                })
            }else{
                return callback('','net')
            }
        })
    });
}
//切区续传
export async function cut_resumeUpload(file,val,fileName,serial,callback) {
    var fileName = fileName
    wsMethod.wsSend212()
    console.log('切区续传==',val.bucket)
    Nprogress.start()
    // 删除错误
    store.commit('get_delete_zipError',serial)
    client = ossClient(val)
    ossClient(val).multipartUpload(fileName, file,{
        parallel,
        partSize,
        timeout,
        progress:function(progress,checkpoint){
            if(checkpoint){//分片
                store.commit('get_add_checkpoint',{
                    'fileName':fileName,
                    'serial':serial,
                    'checkpoint':checkpoint
                })
                store.commit('get_add_uploadID',{
                    'serial':serial,
                    'upload':checkpoint.uploadId,
                    'uploadName':checkpoint.name,
                    'client':ossClient(val),
                })             
                upload = checkpoint.uploadId
                uploadName = checkpoint.name
            }
            store.commit('get_add_zipLoading',{
                'serial':serial,
                'value':Number(utils.toPercent(progress))
            })
        },
    }).then(({res, url, name})=> {
        Nprogress.done()
        if (res && res.status == 200) {
            wsMethod.wsSend213()
            // 删除暂存
            store.commit('get_delete_tempFiles',{'name':fileName})
            // 删除切片
            store.commit('get_delete_checkpoint',{"name":fileName})
            // 删除进度
            store.commit('get_delete_zipLoading',serial)
            // // 删除错误
            // store.commit('get_delete_zipError',serial)
            // 删除上传id
            store.commit('get_delete_uploadID',serial)
            let urls = String(res.requestUrls[0])
            return callback(decodeURIComponent(urls.split('?')[0],file))
        }
    }).catch(err=> {
        Nprogress.done()
        wsMethod.wsSend214()
        //手动取消
        if(isCancel){
            isCancel = false
            // 删除暂存
            store.commit('get_delete_tempFiles',{'serial':serial})
            // 删除切片
            store.commit('get_delete_checkpoint',{'serial':serial})
            // 删除进度
            store.commit('get_delete_zipLoading',serial)
            // 删除错误
            store.commit('get_delete_zipError',serial)
            // 删除上传id
            store.commit('get_delete_uploadID',serial)
            return callback()
        }
        errorNum++;
        store.commit('get_add_zipError',{
            'serial':serial,
            'callback':callback
        });
        // 上传失败尝试续传
        getNetworkError(function(network){
            console.log('续传 - 查询得知网络情况',network)
            if(network){
                resumeUpload(serial,function(e){
                    return callback(e)  
                })
            }else{
                return callback('','net')
            }
        })
    });
}
// 取消上传
export async function abortMultipartUpload(serial) {
    let name,uploadId,clients;
    let upInfo = store.getters.is_isZip_uploadID
    for (let i = 0; i < upInfo.length; i++) {
        if(upInfo[i].serial == serial){
            name = upInfo[i].uploadName; // Object所在Bucket的完整路径。
            uploadId = upInfo[i].upload; // 分片上传uploadId
            clients = upInfo[i].client
        }
    }
    const result = await clients.abortMultipartUpload(name, uploadId);
    // 删除暂存
    store.commit('get_delete_tempFiles',{'serial':serial})
    // 删除切片
    store.commit('get_delete_checkpoint',{'serial':serial})
    // 删除进度
    // store.commit('get_delete_zipLoading',serial)
    // 删除错误
    store.commit('get_delete_zipError',serial)
    // 删除上传id
    store.commit('get_delete_uploadID',serial)
    // socker 215删除文件
    wsMethod.wsSend215()
    isCancel = true
    // console.log(result, '=======清除切片====');
}

document.body.ononline = function (e) {
    console.log('网络已经连上');
    // 判断是否存在上传失败的文 件 err_serial 
    let href_ = window.location.href.split('#/')[1]
    let lv = href_.indexOf('?')!=-1? href_.split('?')[0]:''
    if(lv == 'problem'){
        let errs = store.getters.is_isZip_zipError
        console.log('errs',errs)
        for (let i = 0; i < errs.length; i++) {
            resumeUpload(errs[i].serial,errs[i].callback)
        }
    }
}   

// 方法：获取networkError状态
export async function getNetworkError(callback) {
    utils.onLineNetWork(function(flag) {
        if (flag) {//网络通
            return callback(true)
        } else {//网络不通
            return callback(false)
        }
    })
}

//刷新防止zip文件丢失
window.addEventListener("beforeunload", () => {
    if(store.getters.is_isZip_tempFiles.length>0){
        localStorage.setItem("tempFiles", JSON.stringify(store.getters.is_isZip_tempFiles));
        localStorage.setItem("checkpoint", JSON.stringify(store.getters.is_isZip_checkpoint));
        localStorage.setItem("zipError", JSON.stringify(store.getters.is_isZip_zipError));
        localStorage.setItem("uploadID", JSON.stringify(store.getters.is_isZip_uploadID));
    }
});
// 进入判断有无暂存上传文件
if (localStorage.getItem("tempFiles")) {
    store.commit('get_all_tempFiles',JSON.parse(localStorage.getItem('tempFiles')))
    localStorage.removeItem("tempFiles");
}
if (localStorage.getItem("checkpoint")) {
    store.commit('get_all_checkpoint',JSON.parse(localStorage.getItem('checkpoint')))
    localStorage.removeItem("checkpoint");
}
if (localStorage.getItem("zipError")) {
    store.commit('get_all_zipError',JSON.parse(localStorage.getItem('zipError')))
    localStorage.removeItem("zipError");
}
if (localStorage.getItem("uploadID")) {
    store.commit('get_all_uploadID',JSON.parse(localStorage.getItem('uploadID')))
    localStorage.removeItem("uploadID");
}

export default {
    uploadConf,
    uploadPic,
    uploadHttp,
    resumeUpload,
    abortMultipartUpload,
    getNetworkError
}


// WEBPACK FOOTER //
// ./src/lib/zipOss.js